import { ValidateFnType } from '../models/ValidateFnType'

export const validateMatchesPassword: ValidateFnType<string> = (t, value) => ({
  pattern: {
    value: new RegExp(`^${value}$`),
    message: t('validate.passwordsNotMatch'),
  },
})
